import 'vite/modulepreload-polyfill'
// import { createFeedbackForm, createFeedbackTrigger, mountFeedbackTrigger } from './components/form/feedback'
import {
  renderFeedbackForm
} from './components/form/feedback'

import {
  renderWriteForm
} from './components/form/write-us'

import {
  renderAppointmentForm
} from './components/form/appointment'

import {
  renderCommentsForm
} from './components/form/comments'

import {
  renderWai
} from './components/wai'

import { createScrollUp } from './runtime/scroll-up'
import { createCookieAccept } from './runtime/cookie-accept'
import { createCollapsePR} from './runtime/collapse-pr'
import { createCollapseAccordion} from './runtime/collapse-accordion'

/**
 * Демо-версии
 */
import { createIconsDemo } from './components/icons'
//import { createAstraDemo } from './runtime/astra-collapse-demo'

/**
 * Следует использовать эту утилиту для
 * вывода сообщений в консоль браузера.
 */
// import { devLog } from './utils'

/**
 * основной файлы стилей
 */
import './assets/css/main.css'

/**
 * специальный виртуальный стиль парсера UnoCSS.
 */
import 'virtual:uno.css'

/**
 * class="i-lucide-star"
 */

/**
 * -- libs, global, etc
 */
import { register } from 'swiper/element/bundle'

/**
 * -- site
 */
// import { createRobocomicsGallery } from './runtime/robocomics-gallery'
import { createPsGallery } from './runtime/ps-gallery'
import { createPsGalleryElementSingle } from './runtime/ps-element'
import { createPsVideo } from './runtime/ps-video'

/**
 * -- global & site init wrapped in an IIFE
 */
(() => {
  // global init
  // devLog('main:init')

  /**
   * Регистрация веб-компонентов Swiper.
   */
  register()

  /**
   * DomContentLoaded не будет работать для монтирования
   * в некоторых случаях, так как сама функция монтирования
   * приложения срабатывает раньше чем событие DomContentLoaded.
   *
   * Как вариант можно создавать приложения уже после
   * срабатывания DomContentLoaded, практически после
   * загрузки страницы.
   */
  // document.addEventListener('DOMContentLoaded', () => {
  //   devLog('main:init:dom_ready')

  // })

  // devLog('main:init:start')
  // createRobocomicsGallery()
  // createFeedbackTrigger()
  // mountFeedbackTrigger()
  // createFeedbackForm()
  createScrollUp()
  createCookieAccept()
  // createAstraDemo()
  createIconsDemo()
  createCollapsePR()
  createCollapseAccordion()
  createPsGallery()
  createPsGalleryElementSingle()
  createPsVideo()

  /**forms */
  renderFeedbackForm()
  renderWriteForm()
  renderAppointmentForm()
  renderCommentsForm()

  renderWai()

  // devLog('main:astra#bulma')
})()

document.addEventListener('DOMContentLoaded', () => {
  // devLog('main:dom_ready')
})
